import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSendTransitGuaranteeAccessCode = () => {
  return apiClient.customer.sendTransitGuaranteeAccessCode.useMutation({
    onSuccess: () => {
      toast.success('New access code sent successfully!');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Error sending transit guarantee access code!');
    },
  });
};
